import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MathSkillQuestionThumbnail from './MathSkillQuestionThumbnail';
import { useEffect, useState } from 'react';
import { useGetMathSkillQuestionsMutation} from '../../../../features/authentication/questionSearchApiSlice';
import CustomToast from '../../../../components/Toast';
import { useLocation } from 'react-router';
import { ResourceUtils } from '../../../assignments/components/questionDetailComponents/ResourceUtils';
import DetailsBar from '../castleQuestionsSearch/components/questionResults/DetailsBar';
import { faList, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import Modal from '../../../../components/Modal';

const MathSkillQuestions = () => {
  const [getMathSkillQuestions] = useGetMathSkillQuestionsMutation();

  const [mathSkillQuestions, setMathSkillQuestions] = useState([]);
  const [selectedQuestionIds, setSelectedQuestionIds] = useState([]);

  const [questionUsage, setQuestionUsage] = useState(false);
  const [allSelect, setAllSelect] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [questionSort, setQuestionSort] = useState(true);
  const [showEmptyBox, setShowEmptyBox] = useState(false);
  const [showPendingChangesModal, setShowPendingChangesModal] = useState(false);
  const [randomCount, setRandomCount] = useState(10);

  const [selectedPage, setSelectedPage] = useState(1);
  const [pageCount] = useState('1');
  const [pageSize, setPageSize] = useState(25);
  const [dateBasedKey, setDateBasedKey] = useState(new Date().getTime().toString());
  const [searchQuestionId, setSearchQuestionId] = useState('');
  const [previousPageSize, setPreviousPageSize] = useState(pageSize);

  const location = useLocation();
  const { assignmentId, selectedCourseId, selectedLevelId, selectedTopicId, selectedSkillId } = location.state;

  useEffect(() => {
    if (selectedCourseId)
      getMathSkillQuestionsAsync(pageSize);
  }, []);

  const getMathSkillQuestionsAsync = async (questionCount) => {
    setIsLoading(true);
    const option = {
      courseId: selectedCourseId,
      levelId: selectedLevelId,
      topicId: selectedTopicId,
      skillId: selectedSkillId,
      questionCount: questionCount,
      assignmentId: assignmentId ? assignmentId : 0
    };
    const response = await getMathSkillQuestions(option);
    if (response.error) {
      CustomToast(response.error.data.error, 'error');
    }
    else {
      const updatedData = response.data.map(item => ({
        ...item, isSearchFind: true, isSelected: false
      }));
      setMathSkillQuestions(updatedData);
    }
    setIsLoading(false);
  };

  const handleQuestionSort = () => {
    setQuestionSort(!questionSort);
    let sortedData = [];
    if (!questionSort)
      sortedData = ResourceUtils.customSort(mathSkillQuestions, 'questionId', false);
    else
      sortedData = ResourceUtils.customSort(mathSkillQuestions, 'questionId', true);

    setMathSkillQuestions(sortedData);
  };

  const handleAllSelect = () => {
    setAllSelect(!allSelect);
    const selectedQuestions = mathSkillQuestions.map(item => ({
      ...item, isSelected: !allSelect
    }));
    if (!allSelect) {
      const allQuestionIds = mathSkillQuestions.filter(item => item.questionId != 0).map(item => item.questionId);
      setSelectedQuestionIds(allQuestionIds);
    }
    else
      setSelectedQuestionIds([]);
    setMathSkillQuestions(selectedQuestions);
  };

  const searchHandler = (e) => {
    const isValidNumber = /^[0-9]*\.?[0-9]*$/.test(e.target.value);
    if (isValidNumber) {
      setSearchQuestionId(e.target.value);
      let resultQuestions = mathSkillQuestions.map((item) =>
        item.questionId.toString().includes(e.target.value) ? { ...item, isSearchFind: true } : { ...item, isSearchFind: false }
      );
      const searchResults = resultQuestions.filter(item =>item.isSearchFind);
      setShowEmptyBox(searchResults.length == 0);
      setMathSkillQuestions(resultQuestions);
    }
  };


  useEffect(() => {
    if(previousPageSize != parseInt(pageSize))
      handlePageSelect(pageSize);
  }, [pageSize]);

  const handlePageSelect = (e) => {
    setPreviousPageSize(parseInt(e));
    setPageSize(e);
    setAllSelect(false);
    setQuestionSort(true);
    setQuestionUsage(false);
    getMathSkillQuestionsAsync(e);
  };

  const handleRandomlySelectQuestions =()=>{

    if(randomCount === '' || randomCount === 0){
      CustomToast('Please enter a valid number', 'error');
    }
    else if(randomCount > pageSize){
      CustomToast('Number should not be greater than page size.', 'error');
    }
    else{
      const updatedMathSkillQuestions = mathSkillQuestions.map(item => ({
        ...item, isSearchFind: true, isSelected: false
      }));
      setSelectedQuestionIds([]);

      const shuffledItems = shuffleArray(updatedMathSkillQuestions);
      const newSelectedQuestionIds=[];
      const updatedItems = shuffledItems.map((item, index) => {
        if (index < randomCount) {
          newSelectedQuestionIds.push(item.questionId);
          return { ...item, isSelected: true };
        }
        return item;
      });
      const sortedData = ResourceUtils.customSort(updatedItems, 'questionId', true);
      setMathSkillQuestions(sortedData);
      setSelectedQuestionIds(newSelectedQuestionIds);
    }
  };

  const shuffleArray = (array) => {
    let shuffledArray = array.slice(); // Create a copy of the array
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
    }
    return shuffledArray;
  };

  return (
    <>
      <div className="white-card">
        <div className='d-flex'>
          <div className="w-100"><h5>Browse Questions ({pageSize})</h5></div>
        </div>
        <div className='d-flex w-100 align-items-center mt-4 justify-content-between'>
          <div>
            <input
              type="checkbox"
              className="form-check-input me-2 cursor-pointer"
              checked={questionUsage}
              id="questionUsage"
              name="questionUsageCheck"
              onChange={() => setQuestionUsage(!questionUsage)}
            />
            <label className="form-check-label">
              Display question usage
            </label>
            <input
              type="checkbox"
              className="form-check-input me-2 mx-2 cursor-pointer"
              checked={questionSort}
              id="questionSort"
              name="questionSortCheck"
              onChange={handleQuestionSort}
            />
            <label className="form-check-label">
              Display newest questions first
            </label>
          </div>
          <div className='align-items-center d-flex gap-3 justify-content-end'>
            <div>Randomly select questions</div>
            <input
              type="text"
              value={randomCount}
              onChange={(e) => setRandomCount(e.target.value)}
              placeholder=""
              className="form-control w-15"
            />
            <div>
              <Button variant='castleWhite' className='btn-width' onClick={() => handleRandomlySelectQuestions()}>Select</Button>
            </div>
            <button className='btn btn-castleWhite btn-width' onClick={() => selectedQuestionIds.length > 0  ? setShowPendingChangesModal(true) : window.history.back()}>Back</button>
          </div>
        </div>
        <div className='border-dashed-box mb-4 mt-4 py-4'>
          <div className="d-flex justify-content-between align-items-baseline">
            <div className="custom-search position-relative">
              <FontAwesomeIcon icon={faSearch} className='px-1' />
              <input
                type="text"
                value={searchQuestionId}
                onChange={(e) => searchHandler(e)}
                placeholder="Go to Question ID"
                className="form-control w-auto"
              />
            </div>
            <div className='cursor-pointer' style={{color:'#F7931E'}} onClick={handleAllSelect}>
              <FontAwesomeIcon icon={faList} />
              <span className='px-2'>{allSelect? 'UnSelect': 'Select'} all questons on page</span>
            </div>
          </div>
        </div>
        {showEmptyBox && 
        <div className='noResultsContainer'>
          <div className='noResultsBox'>
            <div className='noResultsIconBox mb-4'>
              <FontAwesomeIcon icon={faMagnifyingGlass} />
            </div>
            <div className='fw-500 text-secondary'>No questions were found matching your filter(s).  Please try another search.</div>
          </div>
        </div>
        }
        <MathSkillQuestionThumbnail
          questions={mathSkillQuestions}
          setMathSkillQuestions={setMathSkillQuestions}
          setSelectedQuestionIds={setSelectedQuestionIds}
          selectedQuestionIds={selectedQuestionIds}
          isLoading={isLoading}
          showQuestionUsage={questionUsage}
          selectedCourseId={-selectedCourseId}
          isSelectedOnly={false}
        />
      </div>
      <DetailsBar
        questionsPerPage={pageSize}
        setQuestionsPerPage={setPageSize}
        selectedQuestions={mathSkillQuestions.filter((item)=>item.isSelected)}
        setSelectedQuestions={setMathSkillQuestions}
        selectedPage={selectedPage}
        setSelectedPage={setSelectedPage}
        isYourQuestions={false}
        pageCount={pageCount}
        originalQuestionsList={mathSkillQuestions}
        setQuestionsList={setMathSkillQuestions}
        dateBasedKey={dateBasedKey}
        setDateBasedKey={setDateBasedKey}
        thumbnailType='mathSkill'
        setSelectedQuestionIds={setSelectedQuestionIds}
        selectedQuestionIds={selectedQuestionIds}
        selectedCourseId={selectedCourseId}
      ></DetailsBar>
      <Modal
        isOpen={showPendingChangesModal}
        onClose={() => setShowPendingChangesModal(false)}
        contentWidth='40%'>
        <div className='d-flex flex-column'>
          <div>Going back will remove your currently selected question(s). 
          Would you like to continue?</div>
          <div className='d-flex flex-row gap-3 justify-content-end mt-4'>
            <Button variant='castleRed' className='w-25' onClick={() => setShowPendingChangesModal(false)}>No, stay here</Button>
            <Button variant='castleWhite' className='w-25' onClick={() => {
              setShowPendingChangesModal(false);
              window.history.back();
            }}>Yes</Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MathSkillQuestions;
